// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1bY3t","col":"styles_col__x1us2","fulfillmentStatus":"styles_fulfillmentStatus__24Wo4","emailCol":"styles_emailCol__2Z8VN"};